import React, { useEffect } from "react";

const widthClasses = {
  "11/12": "lg:w-11/12 md:w-10/12 w-11/12",
  "8/12": "lg:w-8/12 md:w-6/12 w-11/12",
  "6/12": "lg:w-6/12 md:w-6/12 w-11/12",
  "4/12": "lg:w-4/12 md:w-5/12 w-11/12",
  "3/12": "lg:w-3/12 md:w-4/12 w-11/12",
  "1/3": "lg:w-1/3 md:w-5/12 w-11/12",
};

const SideModal = ({ isOpen, onClose, children, width, level = "high" }) => {
  const modalWidth = width ? widthClasses[width] : "lg:w-[35%] md:w-1/2 w-full";

  // Lock outer scroll bar when modal opens
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Increased z-indices so overlay covers fixed elements like Navbar (z-50)
  const zIndexLevels = {
    base: { overlay: "z-[60]", modal: "z-[70]" },
    high: { overlay: "z-[70]", modal: "z-[80]" },
    highest: { overlay: "z-[80]", modal: "z-[90]" },
  };
  const zIndex = zIndexLevels[level] || zIndexLevels.high;

  return (
    <>
      {/* Background overlay */}
      <div
        onClick={onClose}
        className={`${isOpen ? "flex" : "hidden"} 
          h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 
          transition-all duration-300 ease-in-out ${zIndex.overlay}`}
      />

      {/* Sliding side modal */}
      <div
        className={`${isOpen ? "translate-x-0" : "translate-x-full"} 
          fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out 
          bg-white flex items-start rounded-l-2xl overflow-hidden 
          ${modalWidth} justify-start ${zIndex.modal}`}
      >
        {isOpen && children}
      </div>
    </>
  );
};

export default SideModal;



// const widthClasses = {
//   "11/12": "lg:w-11/12 md:w-10/12 w-11/12",
//   "8/12": "lg:w-8/12 md:w-6/12 w-11/12",
//   "6/12": "lg:w-6/12 md:w-6/12 w-11/12",
//   "4/12": "lg:w-4/12 md:w-5/12 w-11/12",
//   "3/12": "lg:w-3/12 md:w-4/12 w-11/12",
//   "1/3": "lg:w-1/3 md:w-5/12 w-11/12",
// };
// const SideModal = ({ isOpen, onClose, children, width, level = "base" }) => {
//   const modalWidth = width ? widthClasses[width] : "lg:w-[35%] md:w-1/2 w-full";

//   const zIndexLevels = {
//     base: { overlay: "z-40", modal: "z-50" },
//     high: { overlay: "z-50", modal: "z-60" },
//     highest: { overlay: "z-60", modal: "z-70" },
//   };
//   const zIndex = zIndexLevels[level] || zIndexLevels.base;

//   return (
//     <>
//       {/* Background overlay */}
//       <div
//         onClick={onClose}
//         className={`${isOpen ? "flex" : "hidden"} 
//           h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 
//           transition-all duration-300 ease-in-out ${zIndex.overlay}`}
//       />

//       {/* Sliding side modal */}
//       <div
//         className={`${isOpen ? "translate-x-0" : "translate-x-full"} 
//           fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out 
//           bg-white flex items-start rounded-l-2xl overflow-hidden 
//           ${modalWidth} justify-start ${zIndex.modal}`}
//       >
//         {isOpen && children}
//       </div>
//     </>
//   );
// };

// export default SideModal;